import * as Yup from 'yup';
import pluralize from '@sravni/utils/lib/pluralize';
import { OTP_LENGTH, FIRST_NAME_MIN_LENGTH, FIRST_NAME_MAX_LENGTH } from '../../constansts/index.js';
import { EMAIL_REGEX } from '../../constansts/regExp.js';
import { isPhoneLengthValid, isPhoneCodeAllowed } from '../../helpers/phone.js';

// Функция объединения схем с учётом возможных несовместимостей
const getValidationSchema = (baseSchema, additionalSchema) => {
    if (!additionalSchema)
        return baseSchema;
    // Фильтруем только новые поля, чтобы избежать конфликтов
    const filteredShape = Object.entries(additionalSchema.fields).reduce((acc, [key, value]) => {
        if (!(key in baseSchema.fields)) {
            acc[key] = value;
        }
        return acc;
    }, {});
    // Создаём новую схему с новыми полями
    const cleanedAdditionalSchema = Yup.object(filteredShape);
    return baseSchema.concat(cleanedAdditionalSchema);
};
const otpValidationSchema = Yup.object().shape({
    ["code" /* FIELD_NAME.OTP */]: Yup.string()
        .trim()
        .required('Введите одноразовый код')
        .length(OTP_LENGTH, `Длина одноразового кода - ${OTP_LENGTH} ${pluralize(OTP_LENGTH, 'символ', 'символа', 'символов')}`),
});
const validationSchema = Yup.object()
    .shape({
    ["phone" /* FIELD_NAME.PHONE */]: Yup.string()
        .trim()
        .required('Введите номер телефона')
        .test({
        message: 'Номер указан не полностью',
        test: (value) => {
            if (typeof value !== 'string')
                return true;
            return isPhoneLengthValid(value);
        },
    })
        .test({
        message: 'Неверно указаны первые 4 цифры номера',
        test: (value) => {
            if (typeof value !== 'string')
                return true;
            return isPhoneCodeAllowed(value);
        },
    }),
    ["name" /* FIELD_NAME.NAME */]: Yup.string().when([`$${"name" /* FIELD_NAME.NAME */}Required`], ([isRequired]) => {
        if (isRequired)
            return Yup.string()
                .trim()
                .required('Введите имя')
                .min(FIRST_NAME_MIN_LENGTH, `Минимальная длина имени - ${FIRST_NAME_MIN_LENGTH} ${pluralize(FIRST_NAME_MIN_LENGTH, 'символ', 'символа', 'символов')}`)
                .max(FIRST_NAME_MAX_LENGTH, ({ value }) => `Максимальная длина имени - ${FIRST_NAME_MAX_LENGTH} ${pluralize(FIRST_NAME_MAX_LENGTH, 'символ', 'символа', 'символов')}. Текущая длина - ${value.length} ${pluralize(value.length, 'символ', 'символа', 'символов')}`);
        return Yup.string()
            .transform((value) => value || undefined)
            .min(FIRST_NAME_MIN_LENGTH, `Минимальная длина имени - ${FIRST_NAME_MIN_LENGTH} ${pluralize(FIRST_NAME_MIN_LENGTH, 'символ', 'символа', 'символов')}`)
            .max(FIRST_NAME_MAX_LENGTH, ({ value }) => `Максимальная длина имени - ${FIRST_NAME_MAX_LENGTH} ${pluralize(FIRST_NAME_MAX_LENGTH, 'символ', 'символа', 'символов')}. Текущая длина - ${value.length} ${pluralize(value.length, 'символ', 'символа', 'символов')}`);
    }),
    ["email" /* FIELD_NAME.EMAIL */]: Yup.string().when([`$${"email" /* FIELD_NAME.EMAIL */}Required`], ([isRequired]) => {
        if (isRequired)
            return Yup.string().trim().required('Введите email').matches(EMAIL_REGEX, 'Неверный формат email');
        return Yup.string()
            .trim()
            .transform((value) => value || undefined)
            .matches(EMAIL_REGEX, 'Неверный формат email');
    }),
    ["agreement" /* FIELD_NAME.AGREEMENT */]: Yup.boolean()
        .required('Пожалуйста, поставьте галочку. Без нее мы не сможем продолжить.')
        .oneOf([true], 'Пожалуйста, поставьте галочку. Без нее мы не сможем продолжить.'),
})
    .concat(otpValidationSchema);

export { getValidationSchema, otpValidationSchema, validationSchema };
//# sourceMappingURL=validationSchema.js.map
